// extracted by mini-css-extract-plugin
export default {"table":"style_table__wTnOc","tableCellHead":"style_tableCellHead__7HUcf","tableCell":"style_tableCell__4eJWK"};